var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import units from '../theme/units';
var useStyles = makeStyles(function () { return ({
    smallIcon: {
        minWidth: units.rem(2.5),
        fontSize: units.rem(1.25),
    },
}); });
var ListItemIcon = function (_a) {
    var _b = _a.iconSize, iconSize = _b === void 0 ? 'large' : _b, className = _a.className, rest = __rest(_a, ["iconSize", "className"]);
    var classes = useStyles();
    return (React.createElement(MuiListItemIcon, __assign({}, rest, { className: cx(className, iconSize === 'small' && classes.smallIcon) })));
};
export default ListItemIcon;
//# sourceMappingURL=index.js.map